export class PropertyHistoryModel {
    PROPERTY_ID;
    STATUS;
    LISTING_AGENT_1;
    LISTING_AGENT_4;
    LISTING_AGENT_FIRM;
    PRICE;
    CAP_RATE;
    NET_OPERATING_INCOME;
    PRICE_PER_SQFT;
    RENT_PER_SQFT;
    BASE_RENT;
    VACANCY;
    
    constructor(data) {
        this.PROPERTY_ID = data.ARCIMEDES_ROW_ID;
        this.STATUS = data.STATUS;
        this.LISTING_AGENT_1 = data.LISTING_AGENT_1;
        this.LISTING_AGENT_4 = data.LISTING_AGENT_4;
        this.LISTING_AGENT_FIRM = data.LISTING_AGENT_4_FIRM;

        switch (data.STATUS) {
            case 'Active':
                this.DATE = data.SOURCE === 'STRIVE' ? data.LISTED_DATE : data.LAST_MODIFIED_DATE;
                this.PRICE = data.LIST_PRICE;
                this.CAP_RATE = data.CAPITALIZATION_RATE;
                this.NET_OPERATING_INCOME = data.NET_OPERATING_INCOME;
                this.PRICE_PER_SQFT = data.PRICE_PER_SQFT;
                this.RENT_PER_SQFT = data.RENT_PER_SQFT;
                this.BASE_RENT = data.BASE_RENT;
                this.VACANCY = data.VACANCY;
                break;
            case 'Closed':
                this.DATE = data.CLOSE_OF_ESCROW;
                this.PRICE = data.SOLD_PRICE;
                this.CAP_RATE = data.CLOSE_CAP_RATE;
                this.NET_OPERATING_INCOME = data.CLOSE_NOI;
                this.PRICE_PER_SQFT = data.CLOSE_PRICE_PER_SQFT;
                break;
            case 'Removed':
                this.DATE = data.LAST_MODIFIED_DATE;
                this.PRICE = data.LIST_PRICE;
                this.CAP_RATE = data.CAPITALIZATION_RATE;
                break;
        }
    }
}

export class CurrentHistoryModel extends PropertyHistoryModel {
    LISTING_AGENT_1_FIRST_NAME;
    LISTING_AGENT_1_LAST_NAME;
    LISTING_AGENT_4_FIRST_NAME;
    LISTING_AGENT_4_LAST_NAME;
    LISTING_AGENT_FIRM_NAME;

    constructor(data) {
        super(data);
        this.LISTING_AGENT_1_FIRST_NAME = data.LISTING_AGENT_1_FIRST_NAME;
        this.LISTING_AGENT_1_LAST_NAME = data.LISTING_AGENT_1_LAST_NAME;
        this.LISTING_AGENT_4_FIRST_NAME = data.LISTING_AGENT_4_FIRST_NAME;
        this.LISTING_AGENT_4_LAST_NAME = data.LISTING_AGENT_4_LAST_NAME;
        this.LISTING_AGENT_FIRM_NAME = data.LISTING_AGENT_FIRM_NAME;
    }
}